<app-toast></app-toast>

<div class="grid grid-cols-2 h-screen w-full mobile:flex">

    <!-- Left side -->
    <div class="bg-primary-800 flex flex-col gap-5 mobile:hidden">
        <div class="flex self-center mt-[15%] mx-5">
            <div class="text-white max-w-[550px]">
                <h1 class="text-[38px] font-bold">{{ 'auth.welcome_to' | transloco }}</h1>
                <pre class="text-[16px] leading-6 whitespace-pre-line">{{ 'auth.platform_desc' | transloco }}</pre>

                <div class="flex items-center rounded-md w-[50px] h-1 gap-1 mt-5">
                    <div class="bg-white rounded-full h-1 w-3/4"></div>
                    <div class="flex items-center gap-1">
                        <div class="bg-white rounded-full h-1 w-[5px] opacity-50"></div>
                        <div class="bg-white rounded-full h-1 w-[5px] opacity-50"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex-grow flex justify-end items-end">
            <img src="assets/images/signup-page/dashboard-example.png" alt="Dashboard"
                class="w-[80%] max-w-[1440px] h-auto max-h-[960px] pointer-events-none select-none" />
        </div>
    </div>

    <!-- Right side -->
    <div class="bg-white p-4 z-40 px-[5%] flex flex-col h-full mobile:px-7 mobile:w-screen">
        <div class="flex w-full items-center justify-between mobile:justify-center mobile:mt-10">
            <app-logo></app-logo>
        </div>

        <div class="flex-grow flex flex-col justify-center items-center">
            <div class="max-w-screen-sm w-full self-center mt-[5vh] mobile:mt-5">
                <h1 class="text-5xl font-bold mobile:text-xl mobile:mt-[10vh]">
                    {{ 'auth.mfa.verify_header' | transloco }}
                </h1>

                <p class="mt-2 text-neutral-600 mobile:text-base">
                    {{ 'auth.mfa.check_email' | transloco : { email: maskedEmail } }}
                </p>

                <!-- Code input card -->
                <div class="mt-8 rounded-2xl border border-neutral-200 shadow-sm p-6 mobile:p-4">
                    <div class="flex items-center justify-between">
                        <p class="font-medium text-neutral-900">{{ 'auth.mfa.enter_code' | transloco }}</p>

                        <div class="text-sm text-neutral-500" *ngIf="resendSecondsLeft > 0">
                            {{ 'auth.mfa.resend_in' | transloco }} <span class="font-semibold">{{ resendFormatted
                                }}</span>
                        </div>

                        <button *ngIf="resendSecondsLeft === 0" type="button"
                            class="text-sm font-semibold text-primary hover:underline" (click)="resendCode()"
                            [disabled]="isResending">
                            {{ (isResending ? 'auth.mfa.resending' : 'auth.mfa.resend_code') | transloco }}
                        </button>
                    </div>

                    <!-- Inputs -->
                    <div class="mt-4 flex items-center justify-between gap-3 mobile:gap-2" (paste)="onPaste($event)">
                        <input *ngFor="let box of boxes; let i = index" #codeInput type="text" inputmode="numeric"
                            autocomplete="one-time-code" maxlength="1" class="shadow-sm w-14 h-14 mobile:w-10 mobile:h-10 text-center text-2xl font-semibold rounded-xl border border-neutral-300 bg-white
           focus:outline-none focus:ring-4 focus:ring-primary/20 focus:border-primary transition"
                            (keydown)="onKeyDown($event, i)" />
                    </div>

                    <p class="mt-4 text-sm text-red-600" *ngIf="errorMessage">
                        {{ errorMessage }}
                    </p>

                    <div class="mt-12">
                        <app-primary-button buttonText="{{ 'shared.confirm' | transloco }}"
                            [isDisabled]="!isCodeComplete || isSubmitting"
                            (buttonClick)="confirmCode()"></app-primary-button>
                    </div>
                </div>

                <!-- Sign Out -->
                <div class="mt-6 text-sm">
                    <a routerLink="/auth/logout" class="text-primary hover:underline cursor-pointer">{{
                        'auth.mfa.back_to_sign_in' |
                        transloco }}</a>
                </div>
            </div>
        </div>
    </div>

</div>